export const sumakomiGeocoder = () => {

    class CustomGeocoder {

        constructor(options = {}) {
            this.map = options.map || null;
            this.marker = options.marker || null;
            this.circle = options.circle || null;
            this.geocoder = new google.maps.Geocoder();
        }

        search(placeStr) {

            var place = placeStr || '大阪市中央区';
            var _this = this;

            // 検索実行
            _this.geocoder.geocode({
                "address": place
            }, function (results, status) {

                if (status == 'OK') {

                    // 中心座標を変更
                    _this.map.setCenter(results[0].geometry.location);
                    _this.marker.setPosition(results[0].geometry.location);
                    _this.circle.setCenter(results[0].geometry.location);

                } else {
                    alert('住所が見つかりませんでした');
                }
            });

        }

    }

    window.CustomGeocoder = CustomGeocoder;

}